import * as actionTypes from "../actions/actionType";
import initialState from "./initialState";

export default function categoryListReducer(
  state = initialState.categories,
  action
) {
  switch (action.type) {
    case actionTypes.GET_CATEGORIES_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
